export const common_SET_CURRENTLY_SYNCING = 'common_SET_CURRENTLY_SYNCING' as const
export const common_SET_LAST_SYNC_TIME = 'common_SET_LAST_SYNC_TIME' as const
export const common_COORDINATES_SET = 'common_COORDINATES_SET'
export const common_COORDINATES_INVALIDATE = 'common_COORDINATES_INVALIDATE'
export const common_CLEAR_DATA = 'common_CLEAR_DATA' as const

export type TCommonAction =
    | { type: 'common_SET_CURRENTLY_SYNCING'; syncing: boolean }
    | { type: 'common_SET_LAST_SYNC_TIME'; time: number }
    | { type: typeof common_COORDINATES_SET; lat: number; lon: number }
    | { type: typeof common_COORDINATES_INVALIDATE }
    | { type: typeof common_CLEAR_DATA }

export const setCurrentlySyncing = (syncing: boolean) => ({
    type: common_SET_CURRENTLY_SYNCING,
    syncing,
})

export const setLastSyncTime = (time: number) => ({
    type: common_SET_LAST_SYNC_TIME,
    time,
})

export function coordinatesSet(lat: number, lon: number): TCommonAction {
    return {
        type: common_COORDINATES_SET,
        lat,
        lon,
    }
}

export function coordinatesInvalidate(): TCommonAction {
    return {
        type: common_COORDINATES_INVALIDATE,
    }
}

export const clearData = (): TCommonAction => ({ type: common_CLEAR_DATA })
